const tasksQueue = [];
const pageSize = 10;
let currentExecuting = 0;

/**
 * Will execute the tasks in the queue page by page.
 * Resolves (or rejects) the promise associated with the task after executing it
 */
function executePendingTasks() {
  if (tasksQueue.length > 0 && currentExecuting < pageSize) {
    const availableSpace = pageSize - currentExecuting;
    const nextCalls = tasksQueue.splice(0, availableSpace);
    nextCalls.map(({ func, resolve, reject }) => {
      currentExecuting = currentExecuting + 1;
      func.then((result) => {
        resolve(result);
        currentExecuting = currentExecuting - 1;
      }).catch((error) => {
        currentExecuting = currentExecuting - 1;
        reject(error);
      }).finally(() =>{
        if(currentExecuting === 0) {
          executePendingTasks();
        } 
      });
    });
  } 
}

/**
 * Will run the provided task without allowing other scheduled tasks to run at the same time
 * @typedef {Object} Task
 * @property {function} func - the function to execute
 * @param {Task} task
 * @return {Promise} - a promise that resolves (or rejects) after the task was executed
 */
export function scheduleForExecution(callback) {
  return new Promise((resolve, reject) => {
    tasksQueue.push({ func: callback, resolve, reject });
    if(currentExecuting === 0){
      executePendingTasks();
    }
  });
}